<template>
    <div>
        <mc-modal
            v-model="visible"
            title="一键复制到其他城市"
            width="600px"
            @close="handleClose"
        >
            <div class="copy-city-form">
                <div class="form-label">选择目标城市</div>
                <basic-plan-city-select
                    v-model="toCityIds"
                    :data="cityListData"
                    :disabled-city-ids="disabledCityIdList"
                    :public-ids="selectedIds"
                    multiple
                    :show-select-all="false"
                />
            </div>
            <div
                slot="footer"
                class="modal-footer"
            >
                <mc-button
                    style="margin-right:20px"
                    @click="handleClose"
                >
                    取消
                </mc-button>

                <mc-button
                    type="primary"
                    @click="handleSubmit"
                >
                    确定
                </mc-button>
            </div>
        </mc-modal>
    </div>
</template>

<script>
import BasicPlanCitySelect from '../components/BasicPlanCitySelect';

export default {
    name: 'CopyCityDialog',
    components: {
        BasicPlanCitySelect,
    },
    props: {
        currentCityId: {
            type: Number,
            default: 0,
        },
        cityList: {
            type: Array,
            default: () => ([]),
        },
        allAreaCityList: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            visible: false,
            toCityIds: [],
            disabledCityId: null,
            copyData: null,
        };
    },
    computed: {
        // 将 allAreaCityList 用作 BasicPlanCitySelect 的数据源
        cityListData() {
            return this.allAreaCityList;
        },
        // 从 cityList 中提取城市 ID，用于 BasicPlanCitySelect 的数据过滤
        // 组件内部会根据 selectedIds 过滤显示的城市
        selectedIds() {
            if (!Array.isArray(this.cityList)) {
                return [];
            }
            return this.cityList.map((city) => city.value);
        },
        // 禁用的城市 ID 列表：包括当前城市和已经选中的城市
        disabledCityIdList() {
            const disabledIds = [];
            // 禁用当前城市
            if (this.currentCityId) {
                disabledIds.push(this.currentCityId);
            }
            return disabledIds;
        },
    },
    methods: {
        handleClose() {
            this.visible = false;
        },
        popup() {
            // 初始化目标城市列表为空
            this.toCityIds = [];
            this.visible = true;
        },
        handleSubmit() {
            // 验证是否选择了目标城市
            if (!this.toCityIds.length) {
                this.$message.error('请选择要复制到的城市');
                return;
            }
            this.$emit('success', this.toCityIds);
            this.handleClose();
        },
    },
};
</script>

<style scoped lang="scss">
.copy-city-form {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .form-label {
        color: #585D66;
        white-space: nowrap;
        margin-right: 6px;
        flex-shrink: 0;
    }
}
</style>
